import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import './style.scss'

// Shown when a student's minutes for the activity are done (TimeTracker). The clinician is told on the server when
// the minutes are reached (record-played-time), so there's no "Tell my teacher" step any more.
export const WellDonePopup = ({ setShowWellDonePopup }) => {
    const { timeTrackerData } = useSelector((state) => state.timeTracker)
    const student = useSelector((state) => state.auth.user) || {}
    const history = useHistory()

    useEffect(() => {
        if (document.getElementById('stu-font')) return
        const link = document.createElement('link')
        link.id = 'stu-font'
        link.rel = 'stylesheet'
        link.href = 'https://fonts.googleapis.com/css2?family=Fredoka:wght@500;600;700&display=swap'
        document.head.appendChild(link)
    }, [])

    const game = (student.games || []).find((g) => String(g.id) === String(timeTrackerData.gameId))
    const minutes = Math.max(1, Math.round((timeTrackerData.duration || 0) / 60))
    const clinician = (student.therapist || '').trim().split(' ')[0] || 'Your teacher'
    const backToLessons = () => {
        setShowWellDonePopup(false)
        history.push('/student-activity')
    }
    const keepPlaying = () => setShowWellDonePopup(false)

    return (
        <div className="stu-done-overlay" role="dialog" aria-modal="true" aria-labelledby="stu-done-title">
            <div className="stu-done">
                <div className="stu-done-confetti" aria-hidden="true">
                    {Array.from({ length: 16 }).map((_, i) => (
                        <i key={i} />
                    ))}
                </div>
                <img className="stu-done-art" src="/assets/images/student-home/clever-celebrate.png" alt="" width="170" height="170" />
                <h2 id="stu-done-title">You did it{student.first_name ? ', ' + student.first_name : ''}!</h2>
                <p>
                    You finished {minutes} minutes of <b>{game ? game.game_name : 'practice'}</b>.
                </p>
                <div className="stu-done-stars" aria-hidden="true">
                    <span>★</span>
                    <span>★</span>
                    <span>★</span>
                </div>
                <p className="stu-done-note">{clinician} will see your practice.</p>
                <div className="stu-done-btns">
                    <button type="button" className="stu-done-btn" onClick={backToLessons} autoFocus>
                        Back to my lessons
                    </button>
                    <button type="button" className="stu-done-btn is-ghost" onClick={keepPlaying}>
                        Keep playing
                    </button>
                </div>
            </div>
        </div>
    )
}
